module.exports = __webpack_public_path__ + "fonts/AllerDisplay.4cf80f22.ttf";